import React, { useEffect } from 'react';
import {
    Redirect,
    Route,
    Switch,
    useLocation,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import SecuredApp from './SecuredApp';
import Login from './Login';
import useAuthentication from '../hooks/useAuthentication';
import { createLogger } from '../utils/logging';
import Constants from '../utils/Constants';
import { getPublicConfig } from '../reducers';
import { loadAccessToken } from '../actions/authentication';
import { loadPublicConfig } from '../actions/configuration';
import useEffectOnLoad from '../hooks/useEffectOnLoad';
import SsoLogin from './SsoLogin';

const logger = createLogger('App');

function App() {
    const dispatch = useDispatch();
    useEffectOnLoad(() => {
        dispatch(loadAccessToken());
        dispatch(loadPublicConfig());
    });
    const publicConfig = useSelector(getPublicConfig);
    const location = useLocation();
    useEffect(() => {
        logger.debug(`Pathname changed: ${location.pathname}`);
    }, [location.pathname]);
    const { isUserLoggedIn } = useAuthentication();
    return (
        <>
            <Helmet>
                <title>{publicConfig.appTitle}</title>
                <link href={`data:image/x-icon;base64,${publicConfig.favicon}`} rel="icon" type="image/x-icon" />
            </Helmet>
            <Switch>
                <Route path="/login" component={Login} />
                <Route path="/sso" component={SsoLogin} />
                {isUserLoggedIn ? <SecuredApp timeToIdleInMins={Constants.TIME_TO_IDLE_IN_MINS} idlePopupOffsetInMins={Constants.IDLE_POPUP_OFFSET_IN_MINS} /> : <Redirect to={{ pathname: '/login', state: { from: location } }} />}
            </Switch>
        </>
    );
}

export default App;
